module.exports = __webpack_public_path__ + "static/media/sup_icons_lock-closed.985ef909.svg";